import React from "react";

export const Ad = (props) => {
  return <div id={props.id} style={{ width: "300px", height: "350px" }}></div>;
};
